import React, { useState } from 'react';
import { SidebarContainer, Icon, CloseIcon, SidebarWrapper, SidebarMenu, SidebarLink, SideBtnWrap, SidebarRoute, Imgs, StoreItem } from './SidebarElements';
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import gplaystore from '../../images/google-play-badge.png';
import applestore from '../../images/downloadonappstore.png';

const Sidebar = ({ isOpen, toggle, type }) => {
    const[scrollNav] = useState(false);

    return (
        <SidebarContainer isOpen={isOpen} onClick={toggle}>
            <Icon onClick={toggle}>
                <CloseIcon />
            </Icon>
            <SidebarWrapper>
                <SidebarMenu type={type}>
                    <SidebarLink to="about" onClick={toggle}>About</SidebarLink>
                    <SidebarLink to="discover" onClick={toggle}>Discover</SidebarLink>
                    <SidebarLink to="services" onClick={toggle}>Services</SidebarLink>
                    <SidebarLink to="contact" onClick={toggle}>Contact</SidebarLink>
                </SidebarMenu>
                <SideBtnWrap type={type}>
                <Popup 
                    trigger={<SidebarRoute to="" scrollNav={scrollNav}>Download Pacified® App</SidebarRoute>}
                    modal 
                    nested
                    contentStyle={{
                        maxWidth: '420px',
                        width: '90vw',
                        borderRadius: '20px',
                        padding: '32px 24px',
                        boxShadow: '0 20px 80px rgba(0, 0, 0, 0.15)',
                        border: 'none',
                        backgroundColor: '#fff'
                    }}
                    overlayStyle={{
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        backdropFilter: 'blur(12px)'
                    }}
                >{close => (
                            <div className="modal">
                                <button 
                                    className="close" 
                                    onClick={close}
                                    style={{
                                        background: 'rgba(0, 0, 0, 0.05)',
                                        border: 'none',
                                        fontSize: '18px',
                                        position: 'absolute',
                                        top: '16px',
                                        right: '16px',
                                        cursor: 'pointer',
                                        color: '#666',
                                        width: '32px',
                                        height: '32px',
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        transition: 'all 0.2s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.background = 'rgba(0, 0, 0, 0.1)';
                                        e.target.style.color = '#333';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.background = 'rgba(0, 0, 0, 0.05)';
                                        e.target.style.color = '#666';
                                    }}
                                >
                                &times;
                                </button>
                                <div style={{
                                    textAlign: 'center',
                                    paddingTop: '16px'
                                }}>
                                    <h2 style={{
                                        fontSize: '24px',
                                        fontWeight: '700',
                                        color: '#1a1a1a',
                                        marginBottom: '6px',
                                        letterSpacing: '-0.8px'
                                    }}>
                                        Download Pacified® App
                                    </h2>
                                    <p style={{
                                        fontSize: '15px',
                                        color: '#666',
                                        marginBottom: '28px',
                                        lineHeight: '1.4',
                                        letterSpacing: '0.1px'
                                    }}>
                                        Choose the right pacifier for your baby
                                    </p>
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '12px',
                                        alignItems: 'center'
                                    }}>
                                        <StoreItem 
                                            as="a" 
                                            href="https://apps.apple.com/us/app/pacified/id1528971525" 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            style={{
                                                transition: 'all 0.3s ease',
                                                opacity: '0.95'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.transform = 'translateY(-2px)';
                                                e.target.style.opacity = '1';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.transform = 'translateY(0)';
                                                e.target.style.opacity = '0.95';
                                            }}
                                        >
                                            <Imgs src={applestore} style={{ 
                                                width: '180px', 
                                                height: '54px',
                                                objectFit: 'contain'
                                            }}></Imgs>
                                        </StoreItem>
                                        <StoreItem 
                                            as="a" 
                                            href="https://play.google.com/store/apps/details?id=info.toothprints.pacified" 
                                            target="_blank" 
                                            rel="noopener noreferrer"
                                            style={{
                                                transition: 'all 0.3s ease',
                                                opacity: '0.95'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.transform = 'translateY(-2px)';
                                                e.target.style.opacity = '1';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.transform = 'translateY(0)';
                                                e.target.style.opacity = '0.95';
                                            }}
                                        >
                                            <Imgs src={gplaystore} style={{ 
                                                width: '180px', 
                                                height: '54px',
                                                objectFit: 'contain'
                                            }}></Imgs>
                                        </StoreItem>
                                    </div>
                                </div>
                            </div>
                            )}
                        </Popup>
                </SideBtnWrap>
            </SidebarWrapper>
        </SidebarContainer>
    );
};

export default Sidebar;
